import { Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges,HostBinding,AfterViewInit } from '@angular/core';

import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
declare var $:any;



@Component({
  selector: 'disclaimer',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './disclaimer.component.html',

})
export class DisclaimerComponent implements OnInit {


    homeSubscription:any;
 
    @HostBinding('style.width') public width: string = '100%'; 
     
   
  constructor( msg:MessageService,  toastr: ToastrService, homeservice:HomeService , _router: Router ){


    try{
 
 
      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
 
      if(!tokenA) throw 'Error in parse';
     
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
 
 
      tokenA = JSON.parse(tokenA);
              
  
 
 
      this.homeSubscription=  homeservice.homeData(tokenA.token).subscribe( (res) =>{
   
   //     console.log(res);
 
        if(res.status=='success'){
 
 
         msg.sendMessage({'user':res.user,'notification':res.notification,'type':'left_menu_link','navigations':res.navigation})
 
 
 
       }else{
 
         _router.navigate(['/login']);
 
       }
      
 
    });
 
 
 
    }catch(exc){
        
      _router.navigate(['/login']);
 
    } 
  
 
   }
 
   ngOnInit(){
  
 
   }
 
  
   ngOnDestroy(){
 
     if(this.homeSubscription){
 
      this.homeSubscription.unsubscribe();
       
      }   
     
   }

}
